export enum SubSectionType {
  longText = 'longText',
  keyValueGrid = 'keyValueGrid',
  regularGrid = 'regularGrid',
  accordionContainer = 'accordionContainer',
}
